import { useState } from 'react'
import { Spinner } from '@chakra-ui/react'
import { googleBindInit } from 'API/auth'
import { observer } from 'mobx-react'
import routes from 'routes'
import { toast } from 'react-toastify'
import { getAppOriginUrl } from 'utils/appOrigin'
import { getApiErrorDetails } from 'utils/authError'
import styles from './linkGoogleAccountSection.module.scss'

/** Lets an email/password user link Google (same email on the Google token). Redirects for OAuth when needed. */
const LinkGoogleAccountSection = () => {
  const [loading, setLoading] = useState(false)

  const startRedirectBind = async () => {
    setLoading(true)
    try {
      const returnUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`
      const { bindToken } = await googleBindInit(returnUrl)
      const next = `${getAppOriginUrl()}${routes.linkGoogle.value}?bindToken=${encodeURIComponent(bindToken)}`
      window.location.assign(next)
    } catch (error: unknown) {
      const { message } = getApiErrorDetails(error)
      toast.error(message ?? 'Could not start Google link. Please try again.')
      setLoading(false)
    }
  }

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Link Google account</h2>
      <p className={styles.hint}>
        Sign in with Google once on the secure page. Your Google email must match your RallyPD email. When you return,
        you will see a confirmation here.
      </p>
      <div className={styles.linkRow}>
        <button
          type="button"
          className={styles.linkAction}
          onClick={() => void startRedirectBind()}
          disabled={loading}
        >
          {loading ? 'Opening Google sign-in…' : 'Link with Google'}
        </button>
        {loading && <Spinner size="sm" color="blue.500" thickness="3px" speed="0.8s" />}
      </div>
    </div>
  )
}

export default observer(LinkGoogleAccountSection)
